export class EmailConnection {
  first_name: string;
  last_name: string;
  smtp_url: string;
  port: number;
  secure: boolean = false;
  email_address: string;
  password: string;
}
